const allDevicesCharCountLineItemGiftMsg = () => {
    $(".gift-message-box").keyup(function() {
    	 ($(this).val().length > 200) ? $(this).val($(this).val().substring(0, 200)): $(this).siblings(".gift-message-character-count").text((200 - $(this).val().length) + " characters remaining");
    });
};

const allDevicesSetItemGiftMessage = (item, value) => {
    $("textarea#orderItemGiftMsgTxt_" + item + "").val(value);
};

const allDevicesUpdateGiftMessage = (form) => {
    var data = $(form).serialize();
    $.ajax({
        url: "/webapp/wcs/stores/servlet/GiftMessageUpdate",
        cache: false,
        type: "POST",
        data: data,
        success: function(json) {
            var successResp = json.JSON;
            return false;
        }
    });
};

export {
    allDevicesCharCountLineItemGiftMsg,
    allDevicesSetItemGiftMessage,
    allDevicesUpdateGiftMessage
}
